export default __webpack_public_path__ + "static/media/household-cellar.85bb60f7.svg";